/**
 * Environment-scoped auth cookie names.
 *
 * Every environment shares Domain=.privacybee.com, so the cookie NAMES are
 * suffixed per environment (`.dev`) to stop a dev session from overwriting
 * production's `auth._token.pb` cookie (which caused cross-environment 401
 * refresh loops). Production and local dev use the unsuffixed names (empty
 * suffix).
 */
export const useAuthCookieNames = () => {
    const config = useRuntimeConfig();
    const suffix = config.public.pb.authCookieSuffix || '';

    return {
        tokenCookieName: `auth._token.pb${suffix}`,
        refreshCookieName: `auth._refresh_token.pb${suffix}`,
    };
};
